module.exports = __webpack_public_path__ + "img/2.19d589ae.jpg";